import { render, staticRenderFns } from "./area_user_list_round3.vue?vue&type=template&id=71c2adfc&scoped=true"
import script from "./area_user_list_round3.vue?vue&type=script&lang=js"
export * from "./area_user_list_round3.vue?vue&type=script&lang=js"
import style0 from "./area_user_list_round3.vue?vue&type=style&index=0&id=71c2adfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2adfc",
  null
  
)

export default component.exports